module.exports = __webpack_public_path__ + "static/media/_MIC2515.image.077ced29.png";